<template>
  <div :class="className">
    <v-text-field
      class="mt-0 pt-0"
      v-model="inputValue"
      hide-details
      single-line
      prepend-icon="mdi-magnify"
      v-bind:placeholder="placeholder"
      @keyup.enter="search"
      @click:prepend="search"
      ref="searchGlobal"
      :id="idClass"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'Searchbar',
  props: {
    value: String,
    placeholder: String,
    id: String,
  },
  data(props) {
    return {
      className: props.class,
      inputValue: props.inputValue || '',
      openSearchMobile: false,
      idClass: props.id || 'search',
    };
  },
  methods: {
    search() {
      this.$emit('search', { q: this.inputValue });
    },
    openSearchInMobile() {
      this.openSearchMobile = !this.openSearchMobile;
      this.$emit('openSearchInMobile', this.openSearchMobile);
    },
  },
};
</script>
